import type { IBrandConfig } from './types';

const ULTRAAV_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: {
    kind: 'external',
    url: 'https://ultrasecureav.com/legal/privacy-policy/',
  },
  termsOfService: { kind: 'external', url: 'https://ultrasecureav.com/legal/' },
  websiteTermsOfUse: { kind: 'none' },
  refundPolicy: { kind: 'none' },
  idTheftProtection: { kind: 'none' },
  licensor: 'intersections',
  defaultBillingCategoryKey: 'identityguard_fi',
  copyRightEntity: 'Intersections LLC dba Pango',
  hasCustomerServiceSupport: true,
  ssoRedirectURL: 'https://app.ultravpn.com/ultraid',
  carouselBanners: false,
  security: false,
  billingDetails: false,
  offersAndUpgrades: false,
  finishSetup: false,
  adaChat: true,
  secureUpload: true,
  accountDetails: true,
  // Don't have vault project
  vaultProject: 'ultravpn',
  dwEmailVerification: {
    adaChat: true,
    signInButton: true,
    supportAt: null,
    availability:
      'Representatives are available Monday – Friday, 8AM-11PM ET and Saturday, 9AM-6PM ET.',
  },
  supportPage: {
    pageTitle: {
      active: true,
      title: 'More ways to reach us',
    },
    faq: {
      active: true,
    },
    pages: [],
    call: {
      availability: (
        <>
          Monday – Friday, 8AM-11PM ET <br /> Saturday, 9AM-6PM ET
        </>
      ),
    },
    email: {
      active: true,
      customerSupport: true,
    },
  },
};

export default ULTRAAV_BRAND_CONFIG;
